const invalidHexColorMessage = 'Неверный формат цвета. Ожидается формат #RRGGBB';

export const hexColorRegex = /^#[0-9a-fA-F]{6}$/;

export const hexColor = (value: any) => {
  if (!value) return null;

  if (typeof value === 'string' && !hexColorRegex.test(value)) {
    return invalidHexColorMessage;
  }
};
